/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    header: 'Apps',
    icon: 'PackageIcon',
    i18n: 'Apps',
    items: [
      
      {
        url: null,
        name: 'Forms',
        icon: 'BookIcon',
        i18n: 'Forms',
        submenu: [
          {
            url: '/forms/guest-feedback',
            name: 'app-forms-guest-feedback',
            slug: 'app-forms-guest-feedback',
            i18n: 'Guest Feedback'
          },
          {
            url: '/forms/pre-arrival-form',
            name: 'app-forms-pre-arrival-form',
            slug: 'app-forms-pre-arrival-form',
            i18n: 'Pre-Arrival Form'
          },
          {
            url: '/forms/pre-arrival-checklist-form',
            name: 'pre-arrival-checklist-form',
            slug: 'pre-arrival-checklist-form',
            i18n: 'Pre-Arrival Checklist Form'
          }
        ]
      }

    ]
  }
]
